import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { cn } from "@/lib/utils";

import {
  ControllerFieldState,
  ControllerRenderProps,
  FieldValues,
  UseFormStateReturn,
} from "react-hook-form";
import { Required } from "./Required";

interface FieldProps {
  name: string;
  label?: string;
  required?: boolean;
  render: ({
    field,
    fieldState,
    formState,
  }: {
    field: ControllerRenderProps<FieldValues, string>;
    fieldState: ControllerFieldState;
    formState: UseFormStateReturn<FieldValues>;
  }) => React.ReactElement;
  className?: string;
  labelClassName?: string;
  wrapperClassName?: string;
}

export default function Field({
  name,
  label,
  render,
  required,
  className,
  labelClassName,
  wrapperClassName,
}: FieldProps) {
  return (
    <FormField
      name={name}
      render={(data) => (
        <FormItem className={cn(wrapperClassName)}>
          <div className={cn("flex flex-col gap-3", className)}>
            {label && (
              <FormLabel className={labelClassName}>
                {label} {required && <Required />}
              </FormLabel>
            )}
            <FormControl>{render(data)}</FormControl>
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
